import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=24fe3120&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=24fe3120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe3120",
  null
  
)

export default component.exports